import React from 'react'
import styles from "../components/laymanComp_css/LaymanPage40.module.css"
import { Link } from '@mui/material'

export default function LaymanPage40() {
  return (
    <>
      <div className={styles.layman_block_2}>
          <div className={styles.block1_main_wrpr}>
            <div className={styles.block1_main_bg}>
            <div className={styles.common_width_1}>
              <div className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}>
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    <h1>ARCHETYPE OF PISCES</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.common_width}>
              <div className={styles.layman_archetype_block_main}>
                <div className={`${styles.archetype_block1_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}>
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img className={styles.archetype_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_pisces/archetype_block1_img.webp"/> */}

                    <img
                      className={styles.archetype_img1}
                      src={`${process.env.cloud_url}Layman-Symbolism/layman_page_pisces/archetype_block1_img.webp`}
                    />
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>

                      <div className={styles.yellow_box_heading}>
                        <h1>Navigating the Cosmic Depths: The Forces of Pisces in School of Divine Infinite Being method and Archetypal Astrology</h1>
                      </div>

                      <h4>Introduction:</h4>

                      <p>In the vast tapestry of cosmic archetypes, each astrological sign serves as a unique lens through which we perceive the influences shaping our lives. Among these archetypes, Pisces, as defined within <Link href="https://www.divineinfinitebeing.com">the School of Divine Infinite Being</Link> method and Archetypal Astrology, stands as a mutable water influence, embodying reflective matured wisdom and patient emotional processing. This article delves into the historical roots and transformative power of the Piscean archetype, exploring its role in accepting the cosmic process, navigating endings, and embracing new beginnings.</p>

                      <h4>Pisces: A Mutable Water Influence:</h4>

                      <p>Pisces, as a mutable water sign, symbolizes the culmination of emotional maturity and introspection. It invites individuals to navigate the deep waters of their emotions with patience and wisdom, fostering the ability to accept oneself without the need for manipulation or change. This mutable water influence suggests a fluidity in understanding, reflecting the ever-changing nature of emotions and experiences.</p>
                    </div>
                  </div>
                </div>

                <div className={`${styles.archetype_block2_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}>
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_pisces/pisces_block2_img.webp" /> */}

                    <img
                      className={styles.archetype_img1}
                      src={`${process.env.cloud_url}Layman-Symbolism/layman_page_pisces/pisces_block2_img.webp`}
                    />
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>

                      <h4>Historical Roots and Cosmic Wisdom:</h4>

                      <p>Rooted in ancient symbolism and mysticism, Pisces finds resonance in the Thoth Arcana, represented by <span><i>"The Moon"</i></span> (T-18). The New Moon, associated with Pisces, signifies not just the ending of things but also the moments preceding new beginnings. The Thoth Arcana's imagery, featuring a dung beetle rolling its eggs, encapsulates the essence of Pisces—a recognition that even in the darkest hours, the solar force is ever-present, and a new spring is imminent.</p>

                      <h4>Acceptance and the Cosmic Process:</h4>

                      <p>Pisces beckons individuals to embrace the cosmic process with an understanding that life's culmination, death, is imminent. The dangerous subtlety of Pisces lies in its demand for total acceptance—whether forced or gracefully embraced. Resisting the natural flow of endings leads to a perilous path of horror and madness,emphasizing the importance of surrendering to the cyclical nature of existence.</p>

                      <h4>The Lunar Darkest Phase:</h4>

                      <p>During the New Moon, when the sky is lightless, Pisces allows the brilliance of stars to shine their brightest. This metaphor encapsulates the essence of Piscean influence, encouraging us to find light in the darkest moments. It is a cosmic reminder that wisdom and assurance arise from the culmination of experiences, guiding us on an eternal journey toward new beginnings.</p>

                      <h4>Committing to Cosmic Wisdom:</h4>

                      <p>To work under the influence of Pisces is to commit to drawing deep wisdom from personal experiences. It calls for continuous introspection on the meaning of one's cosmic process, urging individuals to accept themselves completely while recognizing that the past does not dictate the future. Pisces, as an archetype, invites us to navigate life's waters with profound understanding, acknowledging that every ending holds the potential for a new and transformative beginning.</p>

                      <h4>Conclusion:</h4>

                      <p>In the realm of <Link href="https://www.divineinfinitebeing.com">School of Divine Infinite Being</Link> method and Archetypal Astrology, Pisces emerges as a cosmic force guiding us through the depths of emotional wisdom and acceptance. As we embrace the mutable water influence of Pisces, we find ourselves navigating the cosmic process, transcending endings, and welcoming the eternal journey toward new beginnings. In the dance of the celestial bodies, Pisces invites us to reflect, accept, and draw deep cosmic wisdom from the experiences that shape our existence.</p>
                    </div>
                  </div>
                </div>

                <div className={`${styles.archetype_block3_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}>
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.archetype_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_pisces/pisces_block3_img.webp"
                    /> */}

                    <img
                      className={styles.archetype_img1}
                      src={`${process.env.cloud_url}Layman-Symbolism/layman_page_pisces/pisces_block3_img.webp`}
                    />
                  </div>

                  <div className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}>
                    <div className={styles.layman_txt_box_innr}>

                    <div className={styles.yellow_box_heading}>
                      <h1>Astrological Features:</h1>
                    </div>

                    <p><b>Astrological Classification:</b> Pisces is a mutable water sign, representing the culmination of emotional maturity and introspection within the zodiac.</p>

                    <p><b>School of Divine Infinite Being method:</b> Within the framework of <Link href="https://www.divineinfinitebeing.com">School of Divine Infinite Being</Link> methodology and Archetypal Astrology, Pisces is recognized as a cosmic archetype influencing human experiences and perceptions.</p>

                    <p><b>Influences Represented by Signs:</b> In this approach, astrological signs symbolize specific influences on individuals, with Pisces embodying reflective matured wisdom and patient emotional processing.</p>

                    <p><b>Acceptance without Manipulation:</b> Pisces encourages individuals to accept themselves without the impulse to manipulate or change, fostering a deep understanding of personal emotions and experiences.</p>

                    <p><b>Symbolism in Thoth Arcana:</b> The Thoth Arcana associated with Pisces is <i>"The Moon"</i> (T-18), featuring imagery such as a dung beetle rolling its eggs. This symbolism reflects the acceptance of the ending of things and the assurance that new beginnings are imminent even in the darkest moments.</p>

                    <p><b>New Moon Phase:</b> Pisces is linked to the New Moon, signifying both the conclusion of cycles and the moments preceding new beginnings. This phase is characterized by a lightless sky, allowing the brilliance of stars to shine their brightest.</p>
                    </div>
                  </div>
                </div>

                <div className={`${styles.archetype_block4_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}>
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_pisces/pisces_block4_img.webp" /> */}

                    <img
                      className={styles.archetype_img1}
                      src={`${process.env.cloud_url}Layman-Symbolism/layman_page_pisces/pisces_block4_img.webp`}
                    />
                  </div>
                  
                  <div className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}>
                    <div className={styles.layman_txt_box_innr}>

                    <p><b>Eternal Journey:</b> Pisces opens individuals to the vastness of the cosmic process, assuring them that all experiences lead to an eternal journey. The archetype emphasizes the cyclical nature of existence and the transformative power of cumulative experiences.</p>

                    <p><b>Dangerous Subtlety:</b> Pisces carries a dangerous subtlety in its demand for total acceptance. Resisting the natural endings in life is cautioned against, as it may lead to horror and madness. Graceful acceptance is encouraged for a harmonious transition.</p>

                    <p><b>Commitment to Deep Wisdom:</b>  Working under the influence of Pisces requires a commitment to drawing deep wisdom from personal experiences. It advocates for continuous introspection on the meaning of one's cosmic process, accepting oneself completely, and recognizing that the past does not dictate the future.</p>

                    <p><b>Lunar Darkest Phase Symbolism:</b> The symbolism associated with the Lunar Darkest Phase highlights the ability of Pisces to find light in the darkest moments. It underscores the notion that, even in times of obscurity, wisdom and assurance can be derived from the culmination of experiences.</p>

                    <p><b>Navigating Endings and Embracing New Beginnings:</b>  Pisces guides individuals through the process of navigating life's endings with a profound understanding, acknowledging that every conclusion holds the potential for a new and transformative beginning.</p>
                    </div>
                  </div>
                </div>

                <div className={styles.green_sec_cmn_main_wrp}>
                  
                    <Link href="/rota-the-wheel">
                      <div className={styles.green_sec_cmn_sub_wrp}>
                        <h1>The Astrological Tarot association for Pieces is <br/>The Moon. See our alchemical ROTA here</h1>
                      </div>
                    </Link>
                  
                </div>
              </div>
            </div>

            {/* <div className={styles.demo_image}>
              <div className={styles.block1_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_pisces/layman_page40_block1_demo_img.webp'></img>
              </div>

              <div className={styles.block2_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_pisces/layman_page40_block2_demo_img.webp'></img>
              </div>

              <div className={styles.block3_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_pisces/layman_page40_block3_demo_img.webp'></img>
              </div>

              <div className={styles.block4_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_pisces/layman_page40_block4_demo_img.webp'></img>
              </div>

              <div className={styles.block5_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_pisces/layman_page40_block5_demo_img.webp'></img>
                <Link className={styles.blank_link} href="/rota-the-wheel"></Link>
              </div>
            </div> */}
            </div>
          </div>
        </div>
    </>
  )
}